import moment from 'moment';
import { PPDropDown } from 'processor-plataform-ui';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LcAccordion from '../../../../components/Generic/LcAccordion';
import LcLoading from '../../../../components/Generic/LcLoading';
import LcTooltip from '../../../../components/Generic/LcTooltip';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import SideModal from '../../../../components/Layout/SideModal/SideModal';
import { SolicitationView } from '../../../../models/SolicitationView';
import { UserAttendant } from '../../../../models/UserAttendant';
import { WorkTeam } from '../../../../models/WorkTeam';
import { WorkTimeView } from '../../../../models/WorkTimeView';
import { WorkView } from '../../../../models/WorkView';
import HeyHoUserService from '../../../../services/HeyHoUserService/HeyHoUserService';
import WorkService from '../../../../services/WorkService/WorkService';
import WorkTeamService from '../../../../services/WorkTeamService/WorkTeamService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { MenuState } from '../../../../store/reducers/menuReducer';
import SolicitationService from '../../../../services/SolicitationService/SolicitationService'
import { WorkType } from '../../../../models/WorkType';
import WorkTypeService from '../../../../services/WorkTypeService/WorkTypeService';
import { PPTextField } from "processor-plataform-ui";
import LcIconLink from '../../../../components/Generic/LcIconLink';
import LcInfiniteTable from '../../../../components/Data/LcInfiniteTable';
import Parse from 'html-react-parser';
import TextTools from "../../../../services/TextTools/TextTools";
import TimeKeeping from '../../../../components/Generic/TimeKeeping';
import PauseReasonService from '../../../../services/PauseReasonService/PauseReasonService';

interface PropsWorkList {
    work: WorkView;
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    idAbort?: string;
}

interface Option {
    label: string;
    value: string;
}

const EditWork: React.FC<PropsWorkList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const workService: WorkService = new WorkService(props);
    const solicitationService: SolicitationService = new SolicitationService(props);
    const pauseReasonService = new PauseReasonService(props);
    const workTeamService: WorkTeamService = new WorkTeamService(props);
    const heyHoUserService: HeyHoUserService = new HeyHoUserService(props);
    const workTypeService: WorkTypeService = new WorkTypeService(props);
    const [workTimeList, setWorkTimeList] = useState<WorkTimeView[]>([]);
    const [optionsWorkType, setOptionsWorkType] = useState<Option[]>([]);
    const [optionsTeam, setOptionsTeam] = useState<Option[]>([]);
    const [optionsUsers, setOptionsUsers] = useState<Option[]>([]);
    const [work, setWork] = useState<WorkView>({} as WorkView);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedEditRow, setSelectedEditRow] = useState<any>();
    const [valueEditBegin, setValueEditBegin] = useState<any>(undefined);
    const [valueEditEnd, setValueEditEnd] = useState<any>(undefined);
    const [loadingTable, setLoadingTable] = useState<boolean>(false);
    const [solicitation, setSolicitation] = useState<any>(undefined);
    const textTools = new TextTools();
    const [editable, setEditable] = useState<boolean>(false);
    const [pauseReason, setPauseReason] = useState<any[]>([]);

    const retrieveTeams = async () => {
        try {
            var listWorkTeams = await workTeamService.getWorkTeamByBusinessArea(props.solicitation.idBusinessArea);
            var optionsTArray = listWorkTeams.map((item: WorkTeam) => {
                return {
                    label: item.description,
                    value: item.id.toString()
                } as Option;
            }).sort((a: any, b: any) => a.label > b.label ? 1 : -1);

            setOptionsTeam(optionsTArray);
        }
        catch (e) {

        }
    }

    const getPauseReason = async () => {
        try {
            const response = await pauseReasonService.getPauseReasons(props.solicitation.idBusinessArea);
            setPauseReason(response);
        }
        catch (error) {
            console.log(error);
        }
    }

    const retrieveWorkTimeList = async () => {
        try {
            var list = await workService.getWorkTimes(props.work.id);
            setWorkTimeList(list);
            if (list.length > 0) setFirstReason(list[list.length - 1]);
        }
        catch (e) {
            debugger;
        }
    }

    const retrieveUsers = async () => {
        try {
            var listUsers = await heyHoUserService.getUsersAttendant(0, props.work.idWorkTeam as number);
            var optionsTArray = listUsers.map((item: UserAttendant) => {
                return {
                    label: item.nome,
                    value: item.idUser
                } as Option;
            });

            setOptionsUsers(optionsTArray);
        }
        catch (e) {
            debugger;
        }
    }

    const retrieveWorkTypeService = async () => {
        try {
            var listUsers = await workTypeService.getWorkType(props.work.idWorkGroupType as number);
            var optionsTArray = listUsers
                .map((item: WorkType) => {
                    return {
                        label: item.description,
                        value: item.id > 0 ? item.id.toString() : '0'
                    } as Option;
                })
                .sort((a: any, b: any) => a.label > b.label ? 1 : -1);

            setOptionsWorkType(optionsTArray);
        }
        catch (e) {
            debugger;
        }
    }

    const retrieveSolicitation = async () => {
        try {
            const solicitationResponse = await solicitationService.getById(props.work.idSolicitation);
            setSolicitation(solicitationResponse.data);
        }
        catch (e) {
            debugger;
        }
    }

    useEffect(() => {
        if (props.work) {
            init();
        }
    }, [props.work]);

    const init = async () => {
        setLoading(true);

        try {
            setSelectedEditRow(undefined);
            setWork(props.work);
            setLoadingTable(false);
            setSolicitation(undefined);

            if (props.solicitation.idStatus === 1 ||
                props.solicitation.idStatus === 6 ||
                props.work.idStatus === 1 ||
                props.work.idStatus === 6) {
                setEditable(false);
            }
            else {
                setEditable(true);
            }
            await Promise.all([
                await retrieveWorkTypeService(),
                await retrieveTeams(),
                await retrieveUsers(),
                await retrieveWorkTimeList(),
                await retrieveSolicitation(),
                await getPauseReason()
            ])
            // await getPauseReason();
        }
        catch (error) {
            debugger;
        }

        setLoading(false);
    }

    useEffect(() => {
        if (work.idWorkTeam !== 0) {
            retrieveUsers();
        }
    }, [work.idWorkTeam]);

    useEffect(() => {
        if (work.idWorkGroupType !== 0) {
            retrieveWorkTypeService();
        }
    }, [work.idWorkGroupType]);

    const changeData = (event: any) => {
        const { name, value } = event.target;
        setWork({ ...work, [name]: value })
    };

    const [firstReason, setFirstReason] = useState<any>(undefined);

    const saveTimes = async (workTime: WorkTimeView) => {
        setLoadingTable(true);

        try {
            setWorkTimeList([]);

            const newBeginDate = moment(valueEditBegin, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD HH:mm");
            const newEndDate = moment(valueEditEnd, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DD HH:mm");

            workTime = { ...workTime, beginDate: newBeginDate, endDate: newEndDate };

            await workService.editWorkTime(workTime as WorkTimeView);
            await retrieveWorkTimeList();
        }
        catch (error) {
            debugger;
        }

        setLoadingTable(false);
    }

    const handleRowClick = (row: any) => {
        if ((solicitation && solicitation.idStatus !== 6 && solicitation.idStatus !== 7 && solicitation.idStatus !== 8)) {
            if (work.idStatus === 7) {
                const dataAtual = new Date();

                const dataFinalMoment = moment(work.endDate).toDate();
                const dataFinal = moment(new Date(dataFinalMoment.getFullYear(), dataFinalMoment.getMonth(), dataFinalMoment.getDate(), 23, 59)).toDate()

                if (dataAtual < dataFinal) {
                    if ((user.adjustedWorkingTime || user.allowChangeTime)) {
                        setSelectedEditRow(row);
                    }
                }
            }
        }
    }

    const [columnId, setColumnId] = useState<number>(0);

    useEffect(() => {
        if (columnId === 1 || columnId === 2) {
            if (selectedEditRow) {
                setValueEditBegin(moment(selectedEditRow.beginDate).format("YYYY-MM-DDTHH:mm"));
                setValueEditEnd(moment(selectedEditRow.endDate).format("YYYY-MM-DDTHH:mm"));
            }
            else {
                setValueEditBegin(undefined);
                setValueEditEnd(undefined);
            }
        }
        else {
            setSelectedEditRow(undefined);
        }
    }, [selectedEditRow]);

    useEffect(() => {
        if (columnId !== 1 && columnId !== 2) {
            setSelectedEditRow(undefined);
        }
    }, [columnId]);

    const rowClick = {
        rowPointer: true,
        rowFunction: handleRowClick,
        rowSelected: selectedEditRow,
        rowColumn: setColumnId
    }

    const handleValueChangeBegin = (e: any) => {
        setValueEditBegin(e.target.value);
    }

    const handleValueChangeEnd = (e: any) => {
        setValueEditEnd(e.target.value);
    }

    const columns = [
        {
            field: 'reasonId',
            headerName: 'Tipo',
            width: '45%',
            renderCell: (row: any) => {
                if (row.reasonId) return <span>Pausa - {pauseReason.find(pause => pause.id === row.reasonId).description} </span>;
                return <span>{(firstReason === row) ? "Execução" : "Retomada"}</span>;
            }
        },
        {
            field: 'beginDate',
            headerName: 'Início',
            width: '20%',
            overflow: "visible",
            renderCell: (row: any) => {
                if (!row.beginDate) return;

                const data = moment(row.beginDate).fromNow();
                const dataFull = moment(row.beginDate).format("DD/MM/YYYY HH:mm");

                return (
                    <>
                        {
                            valueEditBegin && selectedEditRow && selectedEditRow.id === row.id
                                ? <PPTextField
                                    type={"datetime-local"}
                                    onChange={handleValueChangeBegin}
                                    value={valueEditBegin}
                                    max={moment(valueEditEnd, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") || "2100-12-01T00:00"}
                                />
                                : <LcTooltip trigger='hover' content={dataFull} children={<span>{data}</span>} />
                        }
                    </>
                )
            }
        },
        {
            field: 'endDate',
            headerName: 'Término',
            width: '20%',
            overflow: "visible",
            renderCell: (row: any) => {
                if (!row.endDate) return;

                const data = moment(row.endDate).fromNow();
                const dataFull = moment(row.endDate).format("DD/MM/YYYY HH:mm");

                return (
                    <>
                        {
                            valueEditEnd && selectedEditRow && selectedEditRow.id === row.id
                                ? <PPTextField
                                    type={"datetime-local"}
                                    onChange={handleValueChangeEnd}
                                    value={valueEditEnd}
                                    min={moment(valueEditBegin, "YYYY-MM-DDTHH:mm").format("YYYY-MM-DDTHH:mm") || "2000-01-01T00:00"}
                                />
                                : <LcTooltip trigger='hover' content={dataFull} children={<span>{data}</span>} />
                        }
                    </>

                )
            }
        },
        {
            field: 'endDate',
            headerName: 'Duração',
            width: '10%',
            renderCell: (row: any) => {
                let data = "";
                if (row.endDate) data = moment(row.beginDate).from(moment(row.endDate, true)).replace("há ", "");

                return <span>{data}</span>;
            }
        },
        {
            field: '',
            headerName: '',
            width: '5%',
            overflow: "visible",
            renderCell: (row: any) => {
                return (
                    <>
                        {
                            selectedEditRow && selectedEditRow.id === row.id &&
                            <LcIconLink icon={"ppi ppi-check"} tooltip={"Salvar tempos"} onClick={() => saveTimes(row)} />
                        }
                    </>
                )
            }
        }
    ];

    const Save = async () => {
        setLoading(true);

        try {
            var workToSave = { ...work };
            await workService.updateWork(workToSave);

            if (props.onCloseEvent != null) {
                props.onCloseEvent(true);
            }
        }
        catch (e) {
            console.warn(e);
        }

        setLoading(false);
    }

    return (
        <SideModal
            width={`calc(100% - ${menu.toggle ? '80px' : '260px'})`}
            visible={props.open}
            header={work && work.subject}
            onClose={() => { if (props.onCloseEvent != null) props.onCloseEvent(false); }}
        >
            {
                work &&
                <div style={{ padding: '1rem' }}>
                    <LcLoading loading={loading}>
                        <LCFlexContainer spacing={2} >
                            <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                <LcAccordion title={"Detalhes"} visible={true}>
                                    <LCFlexContainer spacing={2} >
                                        <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                            <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                                                <span>{work.description && Parse(textTools.cleanOnlyEmailParse(work.description))}</span>
                                            </div>
                                        </LCFlexItem>

                                        <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                            <PPTextField
                                                type={"date"}
                                                name={'startDate'}
                                                label={"Data inicial"}
                                                value={work.startDate && moment(work.startDate).format("YYYY-MM-DD")}
                                                onChange={changeData}
                                                max={moment(work.endDate).format("YYYY-MM-DD") || "2100-12-01"}
                                                disabled
                                                readOnly
                                            />
                                        </LCFlexItem>

                                        <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                            <PPTextField
                                                type={"date"}
                                                name={'endDate'}
                                                label={"Data final"}
                                                value={work.endDate && moment(work.endDate).format("YYYY-MM-DD")}
                                                min={moment(work.startDate).format("YYYY-MM-DD") || "2000-01-01"}
                                                onChange={changeData}
                                                disabled
                                                readOnly
                                            />
                                        </LCFlexItem>

                                        {
                                            optionsTeam &&
                                            <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                                <PPDropDown
                                                    name={'idStatus'}
                                                    options={solicitationService.statusList.filter(x => Number(x.value) <= 14)}
                                                    title={'Situação'}
                                                    onChange={changeData}
                                                    value={work.idStatus != null ? work.idStatus.toString() : '0'}
                                                    placeholder={"Situação"}
                                                    placeholderSearch={'Buscar situação'}
                                                    disabled
                                                    readOnly
                                                />
                                            </LCFlexItem>
                                        }

                                        <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                            <PPDropDown
                                                name={'idWorkType'}
                                                options={optionsWorkType}
                                                title={'Tipo de trabalho'}
                                                onChange={changeData}
                                                value={work.idWorkType != null ? work.idWorkType.toString() : '0'}
                                                placeholder={"Tipo de trabalho"}
                                                placeholderSearch={'Buscar tipo de trabalho'}
                                                disabled
                                            />
                                        </LCFlexItem>
                                    </LCFlexContainer>
                                </LcAccordion>
                            </LCFlexItem>
                            <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                <LcAccordion title={"Atendente"} visible={true}>
                                    <LCFlexContainer spacing={2}>
                                        {
                                            optionsTeam &&
                                            <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                                <PPDropDown
                                                    name={'idWorkTeam'}
                                                    options={optionsTeam}
                                                    title={'Equipe'}
                                                    onChange={changeData}
                                                    value={(work.idWorkTeam != null) ? work.idWorkTeam.toString() : '0'}
                                                    placeholder={"Equipe"}
                                                    placeholderSearch={'Buscar equipe'}
                                                    disabled
                                                />
                                            </LCFlexItem>
                                        }
                                        {
                                            optionsUsers &&
                                            <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                                <PPDropDown
                                                    name={'idUser'}
                                                    options={optionsUsers}
                                                    title={'Atendente'}
                                                    onChange={changeData}
                                                    value={(work.idUser != null) ? work.idUser : 0}
                                                    placeholder={"Atendente"}
                                                    placeholderSearch={'Buscar atendente'}
                                                    disabled
                                                />
                                            </LCFlexItem>
                                        }
                                    </LCFlexContainer>
                                </LcAccordion>
                                {
                                    props.solicitation && props.solicitation.timeKeep &&
                                    <div style={{ paddingTop: "30px" }}>
                                        <LCFlexContainer spacing={2}>
                                            <LCFlexItem xs={6} sm={6} md={6} lg={6}>
                                                <TimeKeeping editable={editable} work={work} />
                                            </LCFlexItem>
                                        </LCFlexContainer>
                                    </div>
                                }
                            </LCFlexItem>
                            {
                                workTimeList &&
                                <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                    <LcAccordion title={"Histórico"} visible={true}>
                                        <LcInfiniteTable
                                            loading={loadingTable}
                                            rows={workTimeList}
                                            size={workTimeList.length}
                                            columns={columns}
                                            loadMore={() => { }}
                                        // rowClick={rowClick}
                                        />
                                    </LcAccordion>
                                </LCFlexItem>
                            }

                            <div className={"row end"}>
                                <button
                                    style={{ margin: '10px' }}
                                    className={'lc-button bg-info'}
                                    id={'Ok'}
                                    onClick={() => Save()}
                                    color={"primary"}
                                >
                                    Ok
                                </button>
                                <button
                                    style={{ margin: '10px' }}
                                    className={'lc-button bg-info-alt'}
                                    id={'Cancelar'}
                                    onClick={() => {
                                        if (props.onCloseEvent !== null)
                                            props.onCloseEvent(false);
                                    }}
                                    color={"primary"}>
                                    Cancelar
                                </button>
                            </div>
                        </LCFlexContainer>
                    </LcLoading>
                </div>
            }
        </SideModal>
    );
};

export default EditWork;